import React, { useEffect, useState, useRef } from "react";
import Card from '@mui/material/Card';
import { Paper } from "@material-ui/core";
import "../../styles/devices/mob_UserProfile.css";
import { formatHistoryDate } from '../../api/utils/strings';
import { Button, TextField, Select, MenuItem } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { IconButton } from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid";
import { useDataProvider } from "../../api/DataProvider";
import { useCommProvider } from "../../api/CommProvider";
import { pDataOrigin, pDataOriginLabel, pTeamActivityViewTab, pDataProvider } from "../../utils/parameters";
import { RecordDialog } from "../../components/dialog/RecordDialog";
import { Tabs, Tab } from "@material-ui/core";
import ConstructionIcon from '@mui/icons-material/Construction';


import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import { useTranslation } from "react-i18next";


export function DialogTeamActivity(props) {

  const { infoTeam } = props;
  const { t } = useTranslation("global")
  
  const [pageSize, setPageSize] = useState(10);
  const [listActiveMembers, setListActiveMembers] = useState([]);
  const input_user_id = useRef("");

  const [ openDialog, setOpenDialog ] = useState(false);
  const { currentUser, token_id, comm_getPublicURLVideoData } = useDataProvider();
  const { comm_getRecords, comm_removeRecord, comm_revertRemoveRecord, comm_getVideoData } = useCommProvider();
  const [ arr_records, set_arr_records ] = useState([]);
  const [ selected_record, setSelectedRecord ] = useState({});
  const [ selected_video, setSelectedVideo ] = useState(null);
  const [ selected_videoRef, setSelectedVideoRef ] = useState(null);

  const [ split_id, setSplit_id ] = useState(0);
  const [target_user_id, setTarget_user_id ] = useState("")
  const [ tabValue, setTabValue ] = useState(pTeamActivityViewTab.videos);
  const [ type, setType ] = useState('VIDEO'); 



  const NUMBER_CHARACTERS_VALID = 28
  const [sortModel, setSortModel] = useState([{ field: "timestamp", sort: "desc" }]);
  const [columns, setColumns] = useState([
    // { field: "filename", headerName: t("sTable.record"), sortable: false, flex: 0.5 },
    { field: "feedback_lemma", headerName: t("sRecorder.record_field_lemmma"), sortable: false, flex: 0.35 },
    { field: "user_id", headerName: t("sTable.user"), sortable: false, flex: 0.6 },
    { field: "origin", headerName: t("sTable.origin"), sortable: false, flex: 0.4, renderCell: (params) => gridOriginFormated(params) },
    { field: "timestamp", headerName: t("sTable.date"), sortable: true, flex: 0.5, renderCell: (params) => formatHistoryDate(params.row.timestamp) },
    { field: "available", headerName: t("sTable.state"), sortable: false, flex: 0.3, renderCell: (params) => gridAvailable(params) },
    { field: "feedback_report", headerName: t("sTable.evaluated"), sortable: false, flex: 0.35, renderCell: (params) => gridCheckIsEvaluated(params) },
    // { field: "feedback_report_validation", headerName: t("sTable.validation"), sortable: false, flex: 0.5, renderCell: (params) => gridManual_report(params, "validation") },
    // { field: "feedback_report_score", headerName: t("sTable.score"), sortable: false, flex: 0.5, renderCell: (params) => gridManual_report(params, "score") },
  ]);

  function gridOriginFormated(params) {
    switch (params.row.origin) {
      case pDataOrigin.collaboration_LABEL:
        return <span> {pDataOriginLabel.collaboration_LABEL} </span>;
      case pDataOrigin.inference_LABEL:
        return <span> {pDataOriginLabel.inference_LABEL} </span>;
      case pDataOrigin.donate_sign_LABEL:
          return <span> {pDataOriginLabel.donate_sign_LABEL} </span>;
      case pDataOrigin.moveYourSkeleton_LABEL:
            return <span> {pDataOriginLabel.moveYourSkeleton_LABEL} </span>;
      case pDataOrigin.newVariant_LABEL:
        return <span> {pDataOriginLabel.newVariant_LABEL} </span>;
      case pDataOrigin.newSign_LABEL:
        return <span> {pDataOriginLabel.newSign_LABEL} </span>;
      case pDataOrigin.newDefinition_LABEL:
        return <span> {pDataOriginLabel.newDefinition_LABEL} </span>;
      default:
        return <span> {pDataOriginLabel.unknown_LABEL} </span>;
    }
  }


  function gridAvailable(params) {
    const issueUser = params.row.available === true ? t("sRecorder.record_available"): t("sRecorder.record_pending_delete");
    return <span>{issueUser}</span>
  }

  function gridCheckIsEvaluated(params){
    let evaluated = true

    if (params.row.feedback_report['validation'] === undefined){
      evaluated = false
    }
    if (params.row.feedback_report['validation']==null && params.row.feedback_report['score']==null && params.row.feedback_report['comment']==null){
      evaluated = false
    }

    if (evaluated === true){
      return <CheckIcon style={{ color: 'green', margin: 'auto' }} />
    }else{
      return <ClearIcon style={{ color: 'red', margin: 'auto' }} />
    }
    
  }

  function gridManual_report(params, type) {
    let data = params.row.feedback_report[type]
    if (data == undefined || data == null){
      data = ' - '
    }
    if (typeof data === 'boolean') {
      data = data ? t("sRecorder.record_success").toUpperCase() : t("sRecorder.record_failure").toUpperCase();
    }
    return <span>{data}</span>
  }

  function gridSystem_report(params) {
    const report = params.row.report.length > 1 ? params.row.report[9] : 'None'; 
    return <span>{report}</span>
  }


  useEffect(() => {
    const arr_active_members = infoTeam['users_state']
        .filter(item => item['accesible'])
        .map(item => "["+item['id']+"] - "+ item['name']);
    // console.log('arr_active_members:', arr_active_members)
    setListActiveMembers(arr_active_members)
    // console.log("🚀 ~ file: DialogTeamActivity.js:125 ~ DialogTeamActivity ~ infoTeam:", infoTeam)
  }, [infoTeam]);
  


  function handlePageSizeChange(params) {
    setPageSize(params.pageSize);
  }

  function handleChange(e){
    // console.log(e.target.value)
    const user_id = e.target.value.replace(/.*\[(.*?)\].*/, "$1");
    setTarget_user_id(user_id)
  }

  function handleChangeType(e){
    setType(e.target.value)
  }


  async function handleRowClick(params, event) {
    setSelectedRecord(params.row);

    let origin = pDataOrigin.unknown_LABEL;
    if (params.row['origin'] === pDataOrigin.collaboration_LABEL){
      origin = pDataOrigin.collaboration_LABEL;
    }else if (params.row['origin'] === pDataOrigin.inference_LABEL){
      origin = pDataOrigin.inference_LABEL;
    }else if (params.row['origin'] === pDataOrigin.donate_sign_LABEL){
      origin = pDataOrigin.donate_sign_LABEL;
    }else if (params.row['origin'] === pDataOrigin.moveYourSkeleton_LABEL){
      origin = pDataOrigin.moveYourSkeleton_LABEL;
    }else if (params.row['origin'] === pDataOrigin.newVariant_LABEL){
      origin = pDataOrigin.newVariant_LABEL;
    }else if (params.row['origin'] === pDataOrigin.newSign_LABEL){
      origin = pDataOrigin.newSign_LABEL;
    }else if (params.row['origin'] === pDataOrigin.newDefinition_LABEL){
      origin = pDataOrigin.newDefinition_LABEL;
    }
    
    setSelectedVideo(await comm_getVideoData(token_id, currentUser, origin, params.row['filename']));
    setSelectedVideoRef(await comm_getPublicURLVideoData(pDataProvider.dir_vid_sign, params.row['reference']))
    // console.log("🚀 ~ file: DialogTeamActivity.js:178 ~ DialogTeamActivity ~ params.row['reference']:", params.row['reference'])

    setOpenDialog(true);
  }

  // useEffect(() => {

  //   console.log("🚀 ~ file: DialogTeamActivity.js:178 ~ DialogTeamActivity ~ selected_videoRef:", selected_videoRef)

  // },[selected_videoRef])
  

  async function updateArr_Records(){
    // console.log(target_user_id)
    // console.log(infoTeam['_id'])
    if (target_user_id === 'ALL'){
      set_arr_records(await comm_getRecords(token_id, currentUser, type, null, infoTeam['_id'], 'ALL'));
    }else{
      set_arr_records(await comm_getRecords(token_id, currentUser, type, null, infoTeam['_id'], target_user_id));
    }
  }

  useEffect(() => {
    updateArr_Records();
  },[target_user_id, type])
  


  useEffect(() => {
    // console.log('ARR_RECORDS: ', arr_records)
    const entries = Object.entries(selected_record);  // Comprobar si se habia seleccionado ya un registro previo o no.
    if (entries.length > 0) {
      arr_records.forEach((record) => {
        if (record._id === selected_record._id) {
          setSelectedRecord(record);
        }
      });
    }
  }, [arr_records]);


  

  async function handleRemoveRecord(){
    const record_id_to_delete = selected_record['_id']
    await comm_removeRecord(token_id, currentUser, 'VIDEO', record_id_to_delete)
    updateArr_Records()
  }

  async function handleRevertRemoveRecord(){
    const record_id_to_delete = selected_record['_id']
    await comm_revertRemoveRecord(token_id, currentUser, 'VIDEO', record_id_to_delete)
    updateArr_Records()
  }

  


  return (
    <>
      <div>
      <Paper className="sig_Teams_PaperContent">
          <Card elevation={0}>
            <div className='sig_Teams_Info_Root'>
              <div className='sig_Teams_MainContainer'>
                <div>
                    <div className="sig_SignModal_PaperTitle"> {t("sTeams.show_video_uploaded")} </div>
                </div>
                        <Select 
                          fullWidth
                          className="sig_Teams_Select"
                          size="small"
                          inputRef={input_user_id}
                          onChange={(e) => handleChange(e)}
                          >

                          <MenuItem value="">
                            {/* Empty option label */}
                            <em>&nbsp;</em>
                          </MenuItem>
                          <MenuItem value="ALL">
                            {/* Empty option label */}
                            <em> {t("all")} </em>
                          </MenuItem>

                          {listActiveMembers.map((usuario, index) => (
                              <MenuItem key={index} value={usuario}>
                                  <em>{usuario}</em>
                              </MenuItem>
                          ))}
                        </Select>
              </div>
            </div>
          </Card>

          {target_user_id !== ''? (
            <Tabs
                className="sig_SignModal_Tabs"
                value={tabValue}
                onChange={(event, newValue) => {
                  // console.log('CHANGE TAB: ', newValue)
                  setTabValue(newValue);
                }}
                indicatorColor="primary"
                textColor="primary"
                centered
              >
              <Tab className="sig_SignModal_Tab" label={t("sTeams.tab_show_videos").toUpperCase()} />
              <Tab className="sig_SignModal_Tab" label={t("sTeams.tab_show_statistics").toUpperCase()} />

            </Tabs>
          ): (<></>)}
      </Paper>
      </div>

      <div>


        {tabValue === pTeamActivityViewTab.videos && target_user_id !== ''? (
          <div className="sig_BugReport_Root"> 

            <Select  
              style={{width: '50%', margin: 'auto'}}
              size="small"
              className="sig_Teams_Select"
              inputRef={input_user_id}
              onChange={(e) => handleChangeType(e)}
              defaultValue={type}
              >
                <MenuItem value="VIDEO">
                  {/* Empty option label */}
                  <em> {t("sFilter.video")} </em>
                </MenuItem>
                <MenuItem value="SUBMISSION">
                  {/* Empty option label */}
                  <em> {t("sFilter.proposal")} </em>
                </MenuItem>

                {infoTeam['arr_task'].map((tarea_idx, index) => (
                  <MenuItem key={index} value={tarea_idx}>
                    <em>{tarea_idx}</em>
                  </MenuItem>
                ))}

           </Select>

          
            <div className="sig_RecordsRegister_ST_Container">
                <DataGrid
                      autoHeight
                      pageSize={pageSize}
                      onPageSizeChange={handlePageSizeChange}
                      rowsPerPageOptions={[10, 25, 50, 100]}
                      disableSelectionOnClick
                      pagination
                      // disableSelectionOnClick
                      // disableColumnMenu
                      columns={columns}
                      rows={arr_records}
                      sortModel={sortModel}
                      onRowClick={handleRowClick}
                      style={{ cursor: 'pointer' }}
                    />
            </div>
          </div>
        ): (<></>)}

        {(tabValue === pTeamActivityViewTab.statistics && target_user_id !== '') && (
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%'
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              padding: '20px',
              textAlign: 'center'
            }}>
              <ConstructionIcon />
              <h3>En construcción</h3>
            </div>
          </div>
        )}

      </div>
      
      <RecordDialog openDialog={openDialog} setOpenDialog={setOpenDialog} selected_record={selected_record} selected_video={selected_video} selected_videoRef={selected_videoRef} handleRemoveRecord={handleRemoveRecord} handleRevertRemoveRecord={handleRevertRemoveRecord} updateArr_Records={updateArr_Records} isEvaluationVisible={true} isAdmin={true}/>

    </>
);
}
